module.exports = __webpack_public_path__ + "img/TeamComic_017.dc3576c2.png";